import React from 'react';
import { Routes, Route as RouterRoute } from 'react-router-dom';

import Auth from './Auth';
import Private from './Private';
import NotFound from './NotFound';
import RedeemPayout from './RedeemPayout';

import CustomRoute from '../layouts/components/Route';

function Root(props) {
  return (
    <Routes>
      <RouterRoute
        path="/payouts/redeem/*"
        element={
          <CustomRoute {...props} reedemPayoutPage element={<RedeemPayout {...props} />} />
        }
      />
      <RouterRoute
        path="/auth/*"
        element={<CustomRoute {...props} element={<Auth {...props} />} />}
      />
      <RouterRoute
        path="/*"
        element={<CustomRoute {...props} priv element={<Private {...props} />} />}
      />
    </Routes>
  );
}

export default Root;
